import styled from 'styled-components';
export const StyledUpload = styled.div`
  .btn {
    width: 10rem;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 1.2rem;
    padding: 0.4rem;
    align-items: center;
    color: white;
    background-color: #439ae2;
    border-radius: 0.5rem;
    border: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transition: all 0.3s linear;
    margin: 0.5rem;
  }
  .btn:hover {
    background-color: #72b3e9;
    cursor: pointer;
    color: #f8f9fa;
  }
  .fileName {
    text-align: center;
  }
`;
